module.exports = __webpack_public_path__ + "img/ppd_logo_claro.bad0c1a9.png";